import { useState, useEffect,useMemo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { Button } from "@material-ui/core";
import Spacer from "../../components/Spacer";
import MainContainer from "../../components/MainContainer";
import { headerGardian } from "../../data/gardian_header";
import PersonnelService from "../../services/PersonnelService";
import { userDetailContext } from "../../App";
import { useContext } from "react";
import { hasPrivilege } from "../../utils/privilege";
import { useNavigate } from 'react-router-dom';
import PlanningMissionService from "../../services/PlanningMissionService";
import UserService from "../../services/UserService";
import {TextField} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import SearchIcon from '@mui/icons-material/Search';
import LoadingButton from '@mui/lab/LoadingButton';
import GardianService from "../../services/GardianService";
import { DataGrid } from '@mui/x-data-grid';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 0,
  },
  button: {
    float: 'right',
  },
}));

export default function GardianList() {
  const navigate = useNavigate();
  const classes = useStyles();
  const contextData = useContext(userDetailContext);
  const [direction,setDirection]=useState([]);
   const [selectedDirection, setSelectedDirection] = useState('all');
   const [isLoading, setIsLoading] = useState(false);
   const [data,setData]=useState([]);

   const handlefilter = async () => {
    setIsLoading(true);
    loadTable();
    setIsLoading(false);
  };

  const rows = data.map((item, index) => ({
    id: index + 1,
    no: index + 1, 
    ...item
  }));

  const columns = [
    { 
      field: 'no', 
      headerName: 'N°', 
      width: 70,
      headerAlign: 'center',
      align: 'center'
    },
    { 
      field: 'direction_code', 
      headerName: 'Direction', 
      width: 150 
    },
    { 
      field: 'registration_number', 
      headerName: 'Matricule', 
      width: 250 
    },
    { 
      field: 'nom', 
      headerName: 'Nom et Prénom', 
      width: 450 
    },
    { 
      field: 'function_name', 
      headerName: 'Fonction', 
      width: 150 
    },
  ];


  function loadTable()
  {
    GardianService.liste(selectedDirection).then((result) => {
        if (result && result.data) {   
           setData(result.data);
        }
        }).catch((error) => {
          setData([]);
        });
  }
  
  useEffect(() => {
        const userData = localStorage.getItem('USER');
        if (userData) {
        UserService.getUserSummaryByUserId(userData)
            .then((result) => {
            if (result && result.data) {
                const dirpers = result.data.direction_id;
                PlanningMissionService.getDirection().then((result) => {
                if (result && result.data) {
                    if (parseInt(dirpers, 10) === 1) { 
                    setDirection(result.data);
                    } else {
                      setSelectedDirection(dirpers);
                    setDirection(result.data.filter(ts => parseInt(ts.direction_id, 10) === parseInt(dirpers, 10)));
                    }
                }
                }).catch((error) => {
                console.error('Error fetching direction data:', error);
                });
            }
            })
            .catch((error) => {
            console.error('Error fetching user summary:', error);
            });
        }
       loadTable();
    }, []);

    const directionOptions = useMemo(() => {
    if (direction.length === 1) return direction;
            return [{ code: 'ALL', name: 'Tous' }, ...direction];
    }, [direction]);
    const defaultValue = useMemo(() => {
    if (direction.length === 1) return direction[0];
    return null;
    }, [direction]);

  const handleDirectionChange = (event, value) => {
    if (!value) {
      setSelectedDirection(null); 
    } else if (value.code === 'ALL') {
      setSelectedDirection('all');
    } else {
      setSelectedDirection(value.direction_id);
    }
    loadTable();
  };

  

  return (
    <MainContainer {...headerGardian}>
      <Grid container item xs={12}>
        <Spacer x={2} />
             <Grid item xs={4}>
                    <Autocomplete
                        onChange={handleDirectionChange}
                        name="direction"
                        options={directionOptions}
                        getOptionLabel={(option) => 
                        option.code === 'ALL' ? 'Tous' : `${option.name} (${option.code})`
                        }
                        renderInput={(params) => (
                            <TextField
                            {...params}
                            fullWidth
                            size="small"
                            variant="outlined"
                            label="Direction"
                             placeholder="Rechercher une direction"
                            InputProps={{ ...params.InputProps, type: 'search' }}
                            />
                        )}
                        value={defaultValue}
                        isOptionEqualToValue={(option, value) => 
                        option.direction_id === value?.direction_id || 
                        (option.code === 'ALL' && value === 'all')
                        }
                        noOptionsText="Aucune direction trouvée"
                        clearOnBlur={false}
                        blurOnSelect
                        />
                                                           
            </Grid>
            <Spacer x={2} />
            <Grid item xs={2}>
               <LoadingButton
                    fullWidth
                    variant="contained"
                    color="primary"
                    loading={isLoading} 
                    loadingPosition="start"
                    startIcon={<SearchIcon />}
                    onClick={handlefilter} 
                >
                    {isLoading ? 'Chargement...' : 'Filtrer'}
                </LoadingButton>
            </Grid>

      </Grid>
      <Spacer y={2} />
      <Grid container spacing={3}>

        <Grid item xs={12}>
          <Paper className={classes.paper} variant="outlined">
           <div style={{ height: 600, width: '100%' }}>
                <DataGrid
                        rows={rows}
                        columns={columns}
                        initialState={{
                        pagination: {
                            paginationModel: { pageSize: 10, page: 0 },
                        },
                        }}
                        pageSizeOptions={[10, 20, 50]}
                        sx={{
                        boxShadow: 2,
                        '& .MuiDataGrid-cell:hover': {
                            backgroundColor: '#f5f5f5',
                        },
                        }}
                    />
            </div>  
          </Paper>
        </Grid>
      </Grid>
    </MainContainer>
  );
}
